/**
 * getDateFormat - Gets a formatted Date instance
 * @param {Date} date - The Date instance to format
 * @return {string} The formatted date for a table element
 */
function getDateFormat(date) {
    return `${date.toDateString()} ${date.toLocaleTimeString()}`;
}

module.exports = getDateFormat;



/** WEBPACK FOOTER **
 ** ./src/utils/getDateFormat.js
 **/